import { useEffect } from 'react';
import { applyEventHighlightsToScene } from '../utils/eventHighlightEntries';
import { resolveRegistryKey } from '../models/registry';
import { getSceneManagerFromRef } from '../utils/sceneManagerRef';

/**
 * Sync live activity events onto the Three.js scene (markers + part heatmap).
 *
 * Fix 7: canvasRef removed from the dep array — it is a stable ref object whose
 * canvasRef is deliberately out of the dep array: it is a stable ref object whose identity never
 * changes. scenePopulatedToken is the ready signal — it changes when the scene is rebuilt. The
 * cleanup clears event markers so stale highlights are not left on unmount.
 */
export default function useSceneEventHighlights(
  canvasRef,
  { liveEvents, sceneLocations, sceneComponents, scenePopulatedToken }
) {
  useEffect(() => {
    const sm = getSceneManagerFromRef(canvasRef);
    applyEventHighlightsToScene(
      sm,
      liveEvents,
      sceneLocations,
      sceneComponents,
      resolveRegistryKey
    );
    return () => {
      const cleanupSm = getSceneManagerFromRef(canvasRef);
      if (cleanupSm) cleanupSm.clearEventMarkers();
    };
  }, [liveEvents, sceneLocations, sceneComponents, scenePopulatedToken]); // canvasRef intentionally omitted — stable ref
}
